/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component } from '@angular/core';
import { BuilderUserContext } from '@gh/builder-shared';
import { BuilderPermission } from '@gh/builder-shared-data';
import { IS_REGION_US } from '@gh/common-shared';

@Component({
  standalone: false,
  selector: 'gh-estimating-tab-container',
  templateUrl: 'estimating-tab-container.component.html',
})
export class EstimatingTabContainerComponent {

  constructor(private userContext: BuilderUserContext) {

  }

  get usRegionAndListPermission(): boolean {
    return IS_REGION_US &&
      this.userContext.hasPermission(BuilderPermission.Setup.Estimating.SalesTaxRates.LIST);
  }
}
